module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('alert-modal', {
    attrs: {
      "title": _vm.alertModal.title,
      "body": _vm.alertModal.body,
      "active": _vm.alertModal.active,
      "actions": _vm.alertModal.actions,
      "dismiss": _vm.alertModal.dismiss
    },
    on: {
      "action": _vm.alertModal.done
    }
  }), _vm._v(" "), (_vm.newDocumentModal.active) ? _c('new-document-modal', {
    class: {
      'is-active': _vm.newDocumentModal.active
    },
    attrs: {
      "options": _vm.newDocumentModal.options
    }
  }) : _vm._e(), _vm._v(" "), (_vm.newContactModal.active) ? _c('new-contact-modal', {
    class: {
      'is-active': _vm.newContactModal.active
    },
    attrs: {
      "options": _vm.newContactModal.options
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editContactModal.active) ? _c('edit-contact-modal', {
    class: {
      'is-active': _vm.editContactModal.active
    },
    attrs: {
      "options": _vm.editContactModal.options
    }
  }) : _vm._e(), _vm._v(" "), (_vm.integrationsModal.active) ? _c('integrations-modal', {
    class: {
      'is-active': _vm.integrationsModal.active
    },
    attrs: {
      "options": _vm.integrationsModal.options
    }
  }) : _vm._e(), _vm._v(" "), (_vm.shareModal.active) ? _c('share-modal', {
    class: {
      'is-active': _vm.shareModal.active
    },
    attrs: {
      "options": _vm.shareModal.options
    }
  }) : _vm._e(), _vm._v(" "), (_vm.whatsNewModal.active) ? _c('whats-new-modal', {
    class: {
      'is-active': _vm.whatsNewModal.active
    },
    attrs: {
      "options": _vm.whatsNewModal.options
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notificationsModal.active) ? _c('notifications-modal', {
    class: {
      'is-active': _vm.notificationsModal.active
    },
    attrs: {
      "options": _vm.notificationsModal.options
    }
  }) : _vm._e(), _vm._v(" "), (_vm.supportFormModal.active) ? _c('support-form-modal', {
    class: {
      'is-active': _vm.supportFormModal.active
    },
    attrs: {
      "options": _vm.supportFormModal.options
    }
  }) : _vm._e(), _vm._v(" "), (_vm.savedMessagesModal.active) ? _c('saved-messages-modal', {
    class: {
      'is-active': _vm.savedMessagesModal.active
    },
    attrs: {
      "options": _vm.savedMessagesModal.options
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cd79a80","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modals/parent-modal-container.vue
// module id = 504
// module chunks = 0